import { render, staticRenderFns } from "./PromoEffectList.vue?vue&type=template&id=502e1c4e&scoped=true&"
import script from "./PromoEffectList.vue?vue&type=script&lang=js&"
export * from "./PromoEffectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502e1c4e",
  null
  
)

export default component.exports